<template>
  <gkModal
    class="modal"
    :model="isShow"
    @destroy="close"
    transition="gk-fade-up"
    loading
  >
    <div class="content">
      <p class="content-title">
        {{ data.data.titleEn }}<br/>
        {{ data.data.title }}
      </p>

      <div class="content-scroll">
        <div class="content-scroll-wrapper">
          <p class="content-scroll-illustrate">{{ data.data.content }}</p>
        </div>
      </div>

      <div class="mask"></div>

      <div class="block-btn">
        <a
          class="block-btn-default"
          :href="data.data.downloadLink"
          target="_blank"
        >
          {{ data.data.download }}
        </a>
        <a
          class="block-btn-link"
          :href="data.data.studyLink"
          target="_blank"
        >
          <div class="block-btn-default">
            {{ data.data.study }}
          </div>
        </a>
      </div>
    </div>

    <div slot="footer"></div>
  </gkModal>
</template>

<script>
// import gkModal from 'gkuiV2/modal'

export default {
  name: 'modal-mobile',

  data: () => ({
    isShow: false
  }),

  props: [
    'data'
  ],

  components: {
    // gkModal
  },

  created () {
    setTimeout(() => { this.isShow = true })

    console.log(this.data)
  },

  methods: {
    close () {
      this.$emit('close', this)
    }
  }
}
</script>

<style lang="scss" scoped>

.modal {
  ::v-deep [gk-modal-main] {
    width: 84vw;
  }

  ::v-deep [gk-modal-close] {
    &::before, &::after {
      width: 14px; height: 2px;
      background: rgba(0, 0, 0, 1);
    }
  }
}

.content {
  position: relative;
  padding: 0;
}

.content-title {
  position: relative;
  margin: 0 auto 34px;
  color: #2F2F30;
  line-height: 22px;
  font-family: Alibaba-PuHuiTi-Heavy;
  font-size: 16px; font-weight: 500;
  text-align: center;

  &::after {
    content: " ";
    position: absolute; left: 50%; bottom: -12px;
    transform: translateX(-50%);
    width: 40px; height: 5px;
    background: #DE3640;
  }
}

.content-scroll {
  position: relative;
  max-height: 300px;
  text-align: left;
  overflow-y: scroll;

}

.mask {
  position: absolute; bottom: 50px;
  width: 100%; height: 30px;
  background: linear-gradient(180deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
}

.content-scroll-wrapper {
  margin-bottom: 20px;
}

.content-scroll-illustrate {
  color: #000000;
  line-height: 24px;
  font-size: 12px; font-weight: 400;
}

.block-btn {
  display: flex; justify-content: center;
  margin-top: 20px;
}

.block-btn-link {
  &:hover .block-btn-text {
    color: #000000;
    opacity: 0.7;
  }
}

.block-btn-default {
  width: 116px; height: 40px;
  margin-right: 20px;
  text-align: center;
  font-size: 15px; font-weight: 500;
  border: 1px solid #000000;
  line-height: 40px;
  color: #000000;
  opacity: 0.9;
  cursor: pointer;

  @include mobile {
    width: 98px; height: 34px;
    line-height: 34px
  }

  &:hover {
    color: #000000;
    opacity: 0.7;
  }
}

</style>
